module.exports = __webpack_public_path__ + "img/838-a41d2f.png";